{
  "id": "baldr",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Balder",
    "en": "Baldr"
  },
  "icon": "gods/baldr",
  "portrait": "gods/baldr-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "fire-giant": 1
  },
  "unlocks": ["fire-giant", "sons-of-sleipnir", "dwarven-auger"],
  "powers": ["ragnarok"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Odin, Thor. Focus: cavalry and siege weapons. Age tech MythicAgeBaldr."
  },
  "fieldMeta": {
    "freeUnitsOnAgeUp": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "MythicAgeBaldr: CreateUnit fire-giant quantity 1, generator AbstractTemple (spawns at a Temple)."
    }
  }
}
